<div class="container">
  <!-- Header usando componente shared -->
  <app-page-header
    title="Actualizar Contacto"
    subtitle="Modifica la información de contacto del usuario"
    icon="user">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="form-alert form-alert--success" *ngIf="showAlertSuccess">
    <i class="form-alert-icon">✓</i>
    <span>{{ message1ForSuccesAlert }}</span>
  </div>
  <section class="update-contact">
    <div class="form-container">
      <form class="form-wrapper" #updateContactForm="ngForm" (ngSubmit)="onSubmit(updateContactForm)">
        <div class="form-content">
          <div class="form-row">
            <div class="form-group">
              <label for="nit" class="form-label form-label--required">NIT</label>
              <input type="text" id="nit-input" class="form-input" placeholder="Ingresa NIT"
                [(ngModel)]="updateContactRequest.nit" name="nitInput" #nitModel="ngModel" required
                [ngClass]="{'form-input--error': nitModel.invalid && nitModel.touched}">
              <div *ngIf="nitModel.invalid && nitModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
            <div class="form-group">
              <label for="name" class="form-label form-label--required">Usuario</label>
              <input type="text" id="name" class="form-input" placeholder="Ingresa usuario"
                [(ngModel)]="updateContactRequest.username" name="usernameInput" #usernameModel="ngModel" required
                [ngClass]="{'form-input--error': usernameModel.invalid && usernameModel.touched}">
              <div *ngIf="usernameModel.invalid && usernameModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="phone" class="form-label form-label--required">Celular</label>
              <div class="form-input-group">
                <select 
                  class="form-select form-select--code" 
                  [(ngModel)]="countryCode"
                  name="countryCode"
                >
                  <option *ngFor="let country of countryCodes" [value]="country.code">
                    {{ country.flag }} {{ country.code }}
                  </option>
                </select>
                <input 
                  type="tel" 
                  id="phone" 
                  class="form-input form-input--phone"
                  placeholder="Ingresa 10 dígitos"
                  name="phoneInput"
                  [(ngModel)]="phoneNumber"
                  #phoneModel="ngModel"
                  required
                  maxlength="10"
                  (blur)="validatePhone()"
                  [ngClass]="{'form-input--error': (!isPhoneValid && phoneModel.touched) || (phoneModel.invalid && phoneModel.touched)}"
                />
              </div>
              <div *ngIf="!isPhoneValid && phoneModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">{{ phoneError }}</span>
              </div>
              <div *ngIf="isPhoneValid && phoneModel.invalid && phoneModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
            <div class="form-group">
              <label for="email" class="form-label form-label--required">Correo electrónico</label>
              <div class="form-input-wrapper">
                <input type="email" id="email" class="form-input" placeholder="Ingresa correo electrónico"
                  [(ngModel)]="updateContactRequest.new_email" name="emailInput" #emailModel="ngModel" required
                  (blur)="validateEmail()"
                  [ngClass]="{'form-input--error': (!isEmailValid && emailModel.touched) || (emailModel.invalid && emailModel.touched)}">
              </div>
              <div *ngIf="!isEmailValid && emailModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">{{ emailError }}</span>
              </div>
              <div *ngIf="isEmailValid && emailModel.invalid && emailModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="form-btn form-btn--cancel" (click)="cancel(updateContactForm)"
            [ngClass]="{'is-active': updateContactForm.valid && isEmailValid && isPhoneValid}">Cancelar</button>
          <button type="submit" class="form-btn form-btn--submit" 
            [ngClass]="{'is-valid': updateContactForm.valid && isEmailValid && isPhoneValid}"
            [disabled]="updateContactForm.invalid || !isEmailValid || !isPhoneValid">Actualizar</button>
        </div>
      </form>
    </div>
  </section>
  <app-confirmation-modal [isVisible]="isModalVisible"
    [confirmationText]="'¿Seguro que deseas actualizar este usuario?'" [confirmButtonText]="'Actualizar'"
    (confirmed)="onConfirm(updateContactForm)" (canceled)="onCancel()"></app-confirmation-modal>
</div>